import React from 'react'
import { Grid, Link, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Link as LinkComponent } from '@src/components/Link'
import { ListKits, MilliplexKitPrice } from '@src/types/graphql-types'
import { ActiveLinkType } from '../../../enum'
import { useFormikContext } from 'formik'
import { MilliplexFormValues } from '@src/routes/Configurators/products/Milliplex/Milliplex'
import { useCurrentUser } from '@src/utils/useCurrentUser'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { useRouter } from 'next/router'

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
    },
  }
})

export interface ProductCardHeaderProps {
  milliplexKit: ListKits | null
}

const ProductCardHeader: React.FC<ProductCardHeaderProps> = ({
  milliplexKit,
}) => {
  const classes = useStyles()
  const formik = useFormikContext<MilliplexFormValues>()

  const { isDealer, currentUser } = useCurrentUser()
  const isAuUser =
    currentUser?.__typename === 'LoggedInUser' &&
    currentUser.metadata?.country &&
    currentUser.metadata?.country === 'AU'
  const kit = milliplexKit && formik.values.selectedKits[milliplexKit?.panelId]
  const router = useRouter()
  const previouslyViewedKit =
    router.query.previouslyViewed || formik.values.previouslyViewed

  const previouslyViewedProduct = previouslyViewedKit === milliplexKit?.panelId
  const priceData: MilliplexKitPrice = {
    currency: kit
      ? kit.data.currency
      : previouslyViewedProduct
        ? '__'
        : milliplexKit?.currency,
    price: kit
      ? kit.data.price
      : previouslyViewedProduct
        ? '__'
        : milliplexKit?.price,
  }
  return (
    <Grid container className={classes.root}>
      <Grid item xs={4}>
        <LinkComponent
          href={`${ActiveLinkType.PDPLink}${milliplexKit?.panelId}`}
          passHref
        >
          <Link>{milliplexKit?.panelId}</Link>
        </LinkComponent>
      </Grid>
      <Grid item xs={6}>
        <p>{milliplexKit?.panelName}</p>
      </Grid>
      <Grid item xs>
        <Grid container direction="row-reverse">
          {!isDealer && isAuUser ? (
            <FormattedMessage id="QUOTE_ITEM" defaultMessage="Quote Item" />
          ) : (
            <>
              {priceData &&
              priceData?.price &&
              !isNaN(parseFloat(priceData?.price)) &&
              parseFloat(priceData?.price) > 0 ? (
                <FormattedNumber
                  style="currency"
                  currencyDisplay="symbol"
                  currency={priceData.currency as string}
                  value={parseFloat(priceData?.price)}
                />
              ) : (
                <span>&#8212;</span>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ProductCardHeader
